module.exports = __webpack_public_path__ + "img/lnicon.6c0e663e.svg";